import React from 'react';
import { Link } from 'gatsby';
import parse from 'html-react-parser';
import { useWipAuthors } from '../../../hooks/use-wip-authors';
import { getPostAuthors } from '../../../model/author';
import { getIssuePath, getPostPath } from '../../../model/post';
import { AuthorLink } from '../index';
import { GatsbyImage } from 'gatsby-plugin-image';
import classNames from 'classnames';

const Spotlight = ({
  type,
  issue,
  lazyLoad,
  post: {
    slug,
    featuredImage,
    title,
    excerpt,
    tghpwipArticleAuthor: authorIds,
    tghpwipArticleSpotlightListingImageTall: spotlightTallImage,
  },
}) => {
  const { name: issueName, slug: issueSlug } = issue;
  const image = spotlightTallImage?.nodes.length
    ? spotlightTallImage.nodes[0]
    : featuredImage?.node;
  const issueColor = issue?.tghpwipIssuesTaxonomyColor;

  const allAuthors = useWipAuthors();
  const postAuthors = getPostAuthors(authorIds, allAuthors);
  const postPath = getPostPath(slug);
  const issuePath = getIssuePath(issueSlug);

  return (
    <article className={`spotlight-card spotlight-card--color-${issueColor}`}>
      {image && type === 'feature' && (
        <Link
          to={postPath}
          className={classNames([
            'spotlight-card__image',
            !!image.gatsbyImage && 'spotlight-card__image--listing',
            !image.gatsbyImage && 'spotlight-card__image--featured-image',
          ])}
        >
          {!!image.gatsbyImage &&
            <GatsbyImage
              alt={image.altText}
              image={image.gatsbyImage}
              sizes="(min-width: 720px) 50vw, 100vw"
              loading={lazyLoad ? 'lazy' : 'eager'}
            />}
          {!image.gatsbyImage && (
            <img
              src={image.publicUrl}
              srcSet={image.srcSet}
              alt={image.altText}
              sizes="(min-width: 720px) 50vw, 100vw"
              loading={lazyLoad ? 'lazy' : 'eager'}
            />
          )}
        </Link>
      )}
      <div className="spotlight-card__content">
        {type !== 'kickoff' && (
          <Link to={issuePath} className="spotlight-card__category intro-titles">
            <div className="intro-titles__label">Spotlight</div>
            <div className="intro-titles__name">{issueName}</div>
          </Link>
        )}
        <div className="spotlight-card__title">
          <Link to={postPath}>
            <h3 className="spotlight-card__title-text">{title}</h3>
          </Link>
        </div>
        <div className="spotlight-card__body">
          <div className="spotlight-card__excerpt">{excerpt && parse(excerpt)}</div>
          <Link to={postPath}>
            <div className="spotlight-card__read-more">Read more {parse(`&#8594`)}</div>
          </Link>
        </div>
        <div className="spotlight-card__author">
          Words by&nbsp;
          {postAuthors.map((author, idx) => (
            <AuthorLink author={author} postAuthors={postAuthors} index={idx} key={idx} />
          ))}
        </div>
      </div>
    </article>
  );
};

export default Spotlight;
